import { fork, all } from "redux-saga/effects";
import authSagas from "./routes/auth/sagas";
import treatmentSagas from "./routes/treatment/sagas";
import usersSagas from "./routes/users/sagas";
import clinicsSagas from "./routes/clinics/sagas";
import districtsSagas from "./routes/districts/sagas";
import servicesSagas from "./routes/services/sagas";
import gameSagas from "./routes/games/sagas";
import clinicalContentSagas from "./routes/clinical_content/sagas";
import notificationCenterSagas from "./routes/components/notification-center/sagas";


export default function* root() {
  yield all([
    fork(authSagas),
    fork(treatmentSagas),
    fork(usersSagas),
    fork(clinicsSagas),
    fork(districtsSagas),
    fork(gameSagas),
    fork(clinicalContentSagas),
    fork(notificationCenterSagas),
    fork(servicesSagas),
  ]);
}
